module.exports = __webpack_public_path__ + "img/agriculture/square_icon4.8b8ab202.png";